module.exports = __webpack_public_path__ + "static/media/1loop2.0a3d9bd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/1loop2.jpg
// module id = 284
// module chunks = 0